import mixpanel from "mixpanel-browser";
import { IComment, ICreatePost, IPost } from "@/lib/community";

// TODO: change to prod f773a059b836addcdc8a4413cee6bdb5
mixpanel.init('f773a059b836addcdc8a4413cee6bdb5', {
  debug: false,
  track_pageview: true,
  persistence: "localStorage",
  autocapture: false,
});

export interface IMTutorialView {
  tutorial_id: string;
  tutorial_title: string;
  author: string;
  tags: string[] | string;
  duration: number | string;
  steps?: number | string;
}

export interface IVideoView {
  video_id: number;
  video_title: string;
  tutorial_id?: string;
  watch_time_seconds: number;
}

export const MixpanelActions = mixpanel
  ? {
      tutorialViewed: (data: IMTutorialView) => {
        mixpanel.track("Tutorial viewed", {
          ...data,
        });
      },
      videoViewed: (data: IVideoView) => {
        mixpanel.track("Video viewed", {
          ...data,
          watch_time_minutes: +(data.watch_time_seconds / 60).toFixed(2),
        });
      },
      tagSelected: (tagName: string) => {
        mixpanel.track("Tag selected", {
          tagName,
        });
      },
      toolSelected: (toolName: string) => {
        mixpanel.track("Tool selected", {
          toolName,
        });
      },
      tutorialIsCompleted: (data: IMTutorialView) => {
        mixpanel.track("Tutorial is completed", {
          ...data,
        });
      },
      tutorialSaved: (data: IMTutorialView) => {
        mixpanel.track("Tutorial is saved", {
          ...data,
        });
      },
      tutorialDismissed: (data: IMTutorialView) => {
        mixpanel.track("Tutorial is dismissed", {
          ...data,
        });
      },
      tutorialTimeSpend: (
        tutorialData: IMTutorialView,
        duration_seconds: number
      ) => {
        mixpanel.track("Tutorial closed", {
          ...tutorialData,
          duration_seconds,
        });
      },
      signedIn: (email: string) => {
        // mixpanel.track("Initiate session", {
        //   email,
        // });
      },

      openCategory: (data: any) => {
        mixpanel.track("Category opened", data);
      },
      selectPlaylist: (data: any) => {
        mixpanel.track("Playlist selected", data);
      },

      // COMMUNITY
      openCommunity: () => {
        mixpanel.track("Open community platform");
      },
      createPost: (post: ICreatePost) => {
        mixpanel.track("Create Post", post);
      },
      openPost: (post: IPost) => {
        mixpanel.track("Open Post", post);
      },
      likePost: (postId: string | number) => {
        mixpanel.track("Like Post", { postId });
      },
      createComment: (comment: IComment) => {
        mixpanel.track("Create comment", comment);
      },
      likeComment: (commentId: string | number) => {
        mixpanel.track("Like comment", { commentId });
      },
      clickUserProfile: () => {
        mixpanel.track("Open user's profile");
      },
    }
  : {
      tutorialViewed: (_data: IMTutorialView) => {},
      tagSelected: (_tagName: string) => {},
      toolSelected: (_toolName: string) => {},
      tutorialIsCompleted: (_data: IMTutorialView) => {},
      tutorialSaved: (_data: IMTutorialView) => {},
      tutorialDismissed: (_data: IMTutorialView) => {},
      tutorialTimeSpend: (
        _tutorialData: IMTutorialView,
        _duration_seconds: number
      ) => {},
      signedIn: (_email: string) => {},
      openCommunity: () => {},
      createPost: (_post: ICreatePost) => {},
      openPost: (_post: IPost) => {},
      likePost: (_postId: string | number) => {},
      createComment: (_comment: IComment) => {},
      likeComment: (_commentId: string | number) => {},
      clickUserProfile: () => {},
      openCategory: (_data: any) => {},
      selectPlaylist: (_data: any) => {},
    };
